import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

import { SharedConfigService } from "@mrdm-self-service-frontend/shared/util-logex-framework-setup";
import {
    AuthorizationPermission,
    AuthorizationProfile
} from "@mrdm-self-service-frontend/shared/types";

@Injectable({
    providedIn: "root"
})
export class SharedAuthorizationApiService {
    private _httpClient = inject(HttpClient);
    private _configService = inject(SharedConfigService);


    searchPermissions(): Observable<AuthorizationPermission[]> {
        const instance = this._configService.getConfiguration()?.instance;

        return this._httpClient.post<AuthorizationPermission[]>(
            `${this._configService.authorizationUrl}api/v3/user/permissions/search`,
            {
                applicationInstances: instance ? [instance] : [],
                OrganizationIdentifierType: "Global",
                AddonsAsParentProduct: true
            }
        );
    }

    getProfile(): Observable<AuthorizationProfile> {
        return this._httpClient.get<AuthorizationProfile>(
            `${this._configService.authorizationUrl}api/v3/user/profile`
        );
    }

    endImpersonation(): Observable<void> {
        return this._httpClient.delete<void>(
            `${this._configService.authorizationUrl}api/v3/impersonation/stop`
        );
    }
}
